import { Check, X } from 'lucide-react';
import { passwordRequirements } from '@/lib/validation/password';

interface PasswordRequirementsProps {
  password: string;
}

export function PasswordRequirements({ password }: PasswordRequirementsProps) {
  const requirements = passwordRequirements.map((req) => ({
    ...req,
    isMet: req.test(password),
  }));

  return (
    <div className="space-y-2">
      <p className="text-muted-foreground text-sm font-medium">Password must contain:</p>
      <ul className="space-y-1.5">
        {requirements.map((req) => (
          <li key={req.id} className="flex items-center gap-2 text-sm">
            {req.isMet ? (
              <Check className="h-4 w-4 text-green-600 dark:text-green-500" />
            ) : (
              <X className="text-muted-foreground/50 h-4 w-4" />
            )}
            <span className={req.isMet ? 'text-green-600 dark:text-green-500' : 'text-muted-foreground'}>
              {req.label}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
